/* import __COLOCATED_TEMPLATE__ from './support-email.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type PulseAccordion } from 'glint/pulse';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  accordion: PulseAccordion;
}

export default class StandaloneSalesforceSupportEmail extends Component<Args> {
  @service store: $TSFixMe;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare notificationsService: $TSFixMe;
  @service declare appService: $TSFixMe;
  @service declare intl: IntlService;

  @tracked supportEmail = this.salesforceConfig.supportEmail;

  get isInValidEmailAddress() {
    if (!this.supportEmail) {
      return true;
    }

    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return !emailRegex.test(this.supportEmail);
  }

  get salesforceConfig() {
    return this.finStandaloneService.salesforceConfig!;
  }

  get errorMessage() {
    if (this.isInValidEmailAddress) {
      return this.intl.t(
        'standalone.salesforce.setup.from-email-address.error-messages.invalid-email',
      );
    }
    return null;
  }

  @action
  async saveSupportEmail() {
    try {
      if (!this.isInValidEmailAddress) {
        let response = await this.salesforceConfig.setSupportEmail(
          this.supportEmail!.trim().toLowerCase(),
        );
        this.store.push(this.store.normalize('dkim-settings', response.dkim_settings));
        this.store.pushPayload({
          'custom-bounce-settings': response.custom_bounce_settings,
          'custom-email-address': response.support_email_address,
        });
      }
      this.notificationsService.notifyConfirmation(
        this.intl.t('standalone.salesforce.setup.from-email-address.success-notification'),
      );
    } catch (e) {
      this.notificationsService.notifyResponseError(e, {
        default: this.intl.t('standalone.salesforce.setup.from-email-address.error-notification'),
      });
      console.error(e);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::SupportEmail': typeof StandaloneSalesforceSupportEmail;
    'standalone/salesforce/setup/support-email': typeof StandaloneSalesforceSupportEmail;
  }
}
